import { DatePipe, DecimalPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle, faBoxOpen, faTruck, faEnvelopeOpenText, faHashtag, faRupeeSign, faInfoCircle, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { OrderService } from '../../service/order-service';
import { ItemsLoading } from '../items-loading/items-loading';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-order-item',
  imports: [NgClass, DecimalPipe, DatePipe, NgFor, FontAwesomeModule, NgIf, NgClass, ItemsLoading],
  templateUrl: './order-item.html',
  styleUrl: './order-item.scss'
})
export class OrderItem {
  @Input() order!: any;
  @Output() orderCancelled = new EventEmitter<void>();
  private orderService = inject(OrderService)
  private snakbar = inject(MatSnackBar)
  protected orderCancelLoading: boolean = false;
  faCheckCircle = faCheckCircle;     // Confirmed
  faBoxOpen = faBoxOpen;             // Packing
  faTruck = faTruck;                 // Shipped
  faEnvelopeOpenText = faEnvelopeOpenText; // Delivered

  faHashtag = faHashtag;
  faCalendarAlt = faCalendarAlt;
  faRupeeSign = faRupeeSign;
  faInfoCircle = faInfoCircle;
  showBankDetails = false;

  toggleBankDetails() {
    this.showBankDetails = !this.showBankDetails;
  }


  statusSteps = [
    { label: 'Confirmed', icon: this.faCheckCircle },
    { label: 'Packing', icon: this.faBoxOpen },
    { label: 'Shipped', icon: this.faTruck },
    { label: 'Delivered', icon: this.faEnvelopeOpenText }
  ];

  get currentStatusIndex(): number {
    return this.statusSteps.findIndex(s => s.label.toLowerCase() === this.order.status.toLowerCase());
  }

  cancelOrder(orderId: string) {
    if (!confirm('Are you sure you want to cancel this order?')) {
      return;
    }
    this.orderCancelLoading = true;
    this.orderService.cancelOrderTransaction(orderId)
      .subscribe({
        next: () => {
          // Update UI immediately (optional but recommended)
          this.orderCancelled.emit()
          this.orderCancelLoading = false;
        },
        error: (err) => {
          console.error('Cancel failed:', err);
          this.orderCancelLoading = false;
          this.snakbar.open('Failed to cancel order. Please try again.', 'Close', { duration: 5000 });
          this.orderCancelLoading = false;
        }
      });
  }

  onImageError(event: Event) {
    (event.target as HTMLImageElement).src = '/placeholder.svg';
  }

}
